module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/assign-player-team/assign-player-team.component.css
// module id = ./src/app/shared/components/assign-player-team/assign-player-team.component.css
// module chunks = main